import React from 'react';
import { createUseStyles } from 'react-jss';
import created from './images/ApplicationSent.svg';
import application from './images/ApplicationStage.svg';
import responses from './images/ResponseStage.svg';
import approved from './images/Approved.svg';
import renewalApproved from './images/Approved.svg';
import renewalStart from './images/ApplicationSent.svg';
import Tooltip from 'components/Tooltip';

const useStyles = createUseStyles(() => ({
  image: {}
}));

export type Status =
  | 'application'
  | 'responses'
  | 'dbs'
  | 'id'
  | 'approved'
  | 'created'
  | 'renewalStart'
  | 'renewalApproved'
  | 'manualVerification';

const statusDescriptions: Record<Status, string> = {
  created: 'Waiting on application form',
  application: 'Waiting on references',
  responses: 'Waiting on final approval',
  approved: 'Check approved',
  renewalStart: 'Renewal in progress',
  renewalApproved: 'Renewal approved',
  manualVerification: 'Manual verification required',
  dbs: 'Waiting on DBS',
  id: 'Waiting on ID verification'
};

type Props = {
  status: Status;
};

// created -> application -> responses -> approved

export default function CheckStatus({ status }: Props) {
  const classes = useStyles();

  const images = {
    application,
    responses,
    approved,
    created,
    renewalApproved,
    renewalStart,
    manualVerification: responses,
    dbs: responses,
    id: responses
  };

  return (
    <Tooltip text={statusDescriptions[status]}>
      <img src={images[status]} className={classes.image} />
    </Tooltip>
  );
}
